/***************************************** Slideshow *****************************/

// slideshow
new Swiper("#productV2Swiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3500,
    },
    navigation: {
        nextEl: '#productV2SwiperRight',
        prevEl: '#productV2SwiperLeft',
    },
    on: {
        slideChange: function () {
            document.querySelector('#productV2SwiperIndex span').innerHTML = this.realIndex + 1;
        }
    }
})

/***************************************** FAQ Slider *****************************/

// setup reviews swipers for all faq items that contain it
let reviewSwipers = document.querySelectorAll('.productV2SliderReviews.swiper');
reviewSwipers.forEach(swiper => {
    new Swiper(swiper, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        breakpoints: {
            801: {
                spaceBetween: 20
            }
        }
    })
})

// needed FAQ variables
const FAQs = document.querySelectorAll('.productV2SliderContentItem');
// get the buttons
let nextBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationNext`);
let prevBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationPrev`);

// true while the close animation is running
let closing = document.querySelector('#productV2Slider').classList.contains('isClosing');

// open slider on 'learn more' click
document.querySelector('#productV2FAQ').addEventListener('click', function () {
    // if the slider is still closing, prevent click
    if (closing) return;

    let sliderFaqs = document.querySelectorAll('.productV2SliderContentItem');
    let foundActive = [...sliderFaqs].some(faq => faq.classList.contains('active'))
    // show the first element if there was no active one before
    !foundActive ? document.querySelector('.productV2SliderContentItem').classList.add('active') : '';

    // call the open slider function
    openSlider();
})

// make next question active
nextBtn.onclick = () => {
    helperFunction(true)
};
prevBtn.onclick = () => {
    helperFunction(false)
};

// helper function for faqs slider nav
function helperFunction(goNext) {
    // needed variables
    let targetEl = "";
    let currentEl = document.querySelector('.productV2SliderContentItem.active');
    let currentIndex = "";
    let numEls = document.querySelectorAll('.productV2SliderContentItem');

    // get the current index
    numEls.forEach((el, index) => {
        if (el.classList.contains('active')) {
            currentIndex = index;
        }
    })

    // no element? exit
    if (!currentEl || numEls.length === 1) {
        return;
    }

    if (currentIndex === numEls.length - 1 && goNext === true) {
        // loop to start if at end
        targetEl = numEls[0];
    } else if (currentIndex === 0 && goNext === false) {
        // loop to end if at start
        targetEl = numEls[numEls.length - 1];
    } else {
        // determine if we need next or previous sibling
        targetEl = goNext === true ? currentEl.nextElementSibling : currentEl.previousElementSibling;
    }
    if (targetEl != null) {
        currentEl?.classList.remove('active');
        targetEl?.classList.add('active');

        // update the dropdown to match the active faq
        let dropdownItem = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`);
        if (dropdownItem) {
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`)?.innerHTML;
            document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
                element.classList.remove("hidden");
                if (element.dataset.id === targetEl.dataset.id) {
                    element.classList.add("hidden");
                }
            });
        }
    }

    // scroll to top of slider content
    document.querySelector('#productV2SliderContent')?.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// open faqs dropdown nav on click
document.querySelector('#productV2SliderDropdownButton').addEventListener('click', function () {
    this.classList.toggle('active');
})

// change faq on dropdown select
document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(item => {
    item.addEventListener('click', function () {
        // change active faq
        document.querySelectorAll('.productV2SliderContentItem').forEach(faq => faq.classList.remove('active'));
        document.querySelector(`.productV2SliderContentItem[data-id="${this.dataset.id}"]`).classList.add('active');

        // show any hidden items in the dropdown from previous selection
        document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => element.classList.remove('hidden'));

        // hide the item in the dropdown that is currently selected
        this.classList.add('hidden')

        // change dropdown label
        // document.querySelector('#productV2SliderDropdownButton span').innerHTML = this.innerHTML;

        // close dropdown
        document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

        // scroll to top of slider content
        document.querySelector('#productV2SliderContent')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
});

// close slider on click
document.querySelector('#productV2SliderClose').addEventListener('click', function () {
    closeSlider();
})

/***************************************** End FAQ Slider *****************************/


// show hide the buy now button
window.addEventListener('scroll', function () {
    if (document.querySelector("#productV2ATC").getBoundingClientRect().top < 0) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();

    // scroll to top on desktop, otherwise scroll to title
    if (window.innerWidth > 800) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else {
        // scroll to the title which is essential the height of the productSwiper
        window.scrollTo({
            top: document.querySelector("#productV2Swiper").clientHeight - 60,
            behavior: 'smooth'
        });
    }
});

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productV2FormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        document.querySelectorAll(".productV2FormRowParent").forEach(item => item.classList.remove('active'));

        // sync action across all forms
        document.querySelectorAll(`.productV2FormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            // update atc lang
            refreshForm();

            // add active class to the parent
            element.closest(".productV2FormRowParent").classList.add('active');
        })
    });
})

/***************************************** FAQs *****************************/

document.querySelectorAll(".productV2FAQItemButton").forEach(button => {
    button.addEventListener("click", function () {
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }
        // remove active from all other faqs
        document.querySelectorAll(".productV2FAQItemButton").forEach(item => item.classList.remove("active"));
        this.classList.add("active");
    })
})


/***************************************** Slider Popup *****************************/

const slider = document.querySelector("#productV2Slider");

function openSlider() {
    // open slider modal
    slider.showModal();
    slider.classList.add("active");

    // update the dropdown to match the active faq
    let activeFAQ = document.querySelector('.productV2SliderContentItem.active').dataset.id;
    document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
        element.classList.remove("hidden");
        if (element.dataset.id === activeFAQ) {
            element.classList.add("hidden");
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = element.innerHTML;
        }
    });

    // no scroll on body
    document.querySelector('body').classList.add('noScroll');
}

function closeSlider() {
    // set closing class
    document.querySelector('#productV2Slider').classList.add('isClosing');

    // remove active from slider
    slider.classList.remove("active");

    // close dropdown if open
    document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

    // Wait a few before closing - animation needs to finish
    setTimeout(() => {
        // close modal
        slider.close();

        // remove no scroll
        document.querySelector('body').classList.remove('noScroll');

        // set closing flag to false
        document.querySelector('#productV2Slider').classList.remove('isClosing');
    }, 300)
}


let dropdown = document.querySelector('#productV2SliderDropdown');
// modal close and/or dropdown close on outside click
slider.addEventListener('click', function (e) {
    if (e.target === this) {
        closeSlider();
    }
    if (!dropdown.contains(e.target)) {
        dropdown.querySelector('button').classList.contains('active') ? dropdown.querySelector('button').classList.remove('active') : "";
    }
})

// accessibility close
slider.addEventListener('close', function () {
    closeSlider();
})

// popup functionality
if (document.querySelector('#productV2SwiperPopups') !== null && window.innerWidth >= 800) {
    function popupImage() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                if (!entry.isIntersecting) return;
                // disconnect once entry is intersecting (visible)
                observer.disconnect();

                // collect the popup items
                const items = [...document.querySelectorAll('.productV2SwiperPopupsPopup.popupImg')];
                let i = 0;

                // infinite loop
                while (true) {
                    items[i].classList.add('active');
                    await sleep(5000);
                    items[i].classList.remove('active');
                    i = (i + 1) % items.length;
                }
            });
        }, {threshold: 0.5});

        // check to see if paper towel section is 50% in view
        observer.observe(document.querySelector('#productV2'));
    }

    // trigger popup function
    popupImage();
}

/***************************************** Rolls *****************************/

// rolls change event
document.querySelectorAll(".productV2FormRollsItem").forEach(function (element) {
    element.addEventListener("click", function () {
        let variant = this.getAttribute("variant");
        // change active product form
        document.querySelectorAll(".productV2Form.active").forEach(item => item.classList.remove('active'));
        document.querySelector(`.productV2Form[variant="${variant}"]`).classList.add("active");

        // update the selected frequency
        document.querySelector(`.productV2Form[variant="${variant}"]`).querySelector('.productV2FormFrequencySelectOption.default')?.click();
        updateSavings(document.querySelector(`.productV2Form[variant="${variant}"] .productV2FormFrequencySelectLabel`).innerText);

        refreshForm();
    });
})

/***************************************** Frequency *****************************/

// frequency open
document.querySelectorAll(".productV2FormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }

        // remove current frequency from dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            let currentSellingPlan = element.closest(".productV2FormFrequency").getAttribute("selling_plan");
            if (parseInt(element.getAttribute('selling_plan')) === parseInt(currentSellingPlan)) {
                element.classList.remove("active");
            }
        })

        // open dropdown
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productV2FormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productV2FormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");

        // re-add current frequency to dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            if (!element.classList.contains("active")) {
                element.classList.add("active");
            }
        })
    }
});

// frequency change
document.querySelectorAll(".productV2FormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productV2FormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productV2FormFrequencySelectLabel").innerHTML = this.innerHTML;
        updateSavings(this.querySelector("span").innerHTML);
    });
})

// frequency setup
// popular is the default
document.querySelector(".productV2Form.active .productV2FormFrequencySelectOption.default")?.click();

// update the savings per year for the subscription option based on the selected frequency
function updateSavings(cadence) {
    // get the cadence
    let cad = parseInt(cadence.match(/\d+/g)[0]);

    // get the active form
    let activeForm = document.querySelector('.productV2Form.active');

    // get the active form's price and compare price for subscription
    let price = activeForm.querySelector('.productV2FormPrice').dataset.subPrice;
    let comparePrice = activeForm.querySelector('.productV2FormPrice').dataset.price;

    // determine the difference in price between subscription and one time purchase
    let difference = (comparePrice - price) / 100;

    // determine how many times per year full deliveries can be made based on cadence
    let yearlyDeliveries = Math.floor((52 / cad));

    if (comparePrice) {
        // calculate savings per year and update the DOM
        let savings = difference * yearlyDeliveries;

        activeForm.querySelector('.productV2FormRowBenefitsSavings span').innerHTML = `Save $${savings} per year`;
    }
}

/**************************************** Upsell + ATC *************************************/

function refreshForm() {
    document.querySelector("#productV2ATC span").textContent = "Add to Cart";

    // check if sold out
    if (document.querySelector(".productV2Form.active.available")) {
        document.querySelector("#productV2ATC").classList.remove("disabled");
    } else {
        document.querySelector("#productV2ATC").classList.add("disabled");
    }
}

refreshForm();

document.querySelector("#productV2ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // exit if disabled
    if (this.classList.contains("disabled")) {
        return;
    }

    // collect formdata

    let formData = {
        id: parseInt(document.querySelector(".productV2Form.active").getAttribute("variant")),
        quantity: 1,
        properties: {
            '_added_at': Date.now() // When the line entered the cart, keeps the mini cart order stable
        }
    };

    // Subscription
    if (document.querySelector(`.productV2FormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productV2Form.active .productV2FormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // // clear cart
    // await fetch("/cart/clear.js");

    // add to cart
    await addProduct(formData);

    // open cart
    await openCart(false);

    // stop loading
    this.classList.remove("loading");
});

/*********************************** Stars *************/

document.querySelector("#productV2Stars").addEventListener("click", function () {
    // show reviews modal
    document.querySelector('#reviewsWidget').showModal();
    // no scroll
    document.body.classList.add("noScroll");
});

// preselect url
(async function () {
    if (urlParams.has("preselect_index")) {
        document.querySelectorAll(".productV2Form.active .productV2FormRollsItem")[urlParams.get("preselect_index")]?.click();
    }
}());
